module.exports = __webpack_public_path__ + "static/logo-2021-54f8c0740fce2100ba74275a558aa5f9.png";